import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, alert_message_html } from '../../common'

$(init)

async function init () {
  let $page = $('#user-inbox-page')
  if ($page.length == 0) {
    return
  }
  try {
    let myinfo = await get_myinfo()
    let loggedin = has_user_loggedin(myinfo)
    if (!loggedin) {
      $page.find('.loading-indicator').addClass('d-none')
      return
    }
    let messages = (await get_json(`/users/get-my-inbox`)).data
    $page.find('.loading-indicator').addClass('d-none')
    if (messages.length == 0) {
      $page.find('.messages-empty').removeClass('d-none')
    } else {
      let $messages = $page.find('.messages')
      $messages.removeClass('d-none')
      $messages.html('')
      for (let message of messages) {
        message.created_at_text = (new Date(parseInt(message.created_at) * 1000))+''
        $messages.append(eval_html_template('#inbox-message-template', message))
      }
    }
    setTimeout(async () => {
      try {
        await post_json('users/mark-read-my-inbox', {})
      } catch (err) {
        console.warn('users/mark-read-my-inbox', err)
      }
    }, 2 * 1000)
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}
